import { Directive, ElementRef, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[appUppercaseText]'
})
export class UppercaseTextDirective {
  @HostBinding('style.text-transform') textTransform = 'uppercase';

  private updating = false;

  constructor(private element: ElementRef<HTMLInputElement | HTMLTextAreaElement>) {}

  @HostListener('input')
  onInput(): void {
    if (this.updating) {
      return;
    }

    const input = this.element.nativeElement;
    const value = input.value || '';
    const upper = value.toUpperCase();

    if (value === upper) {
      return;
    }

    const start = input.selectionStart;
    const end = input.selectionEnd;

    this.updating = true;
    input.value = upper;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    this.updating = false;

    if (start !== null && end !== null) {
      input.setSelectionRange(start, end);
    }
  }
}
